<template>
	<div>
		<div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('course') }}</label>
						<select
							type="text"
							v-model="search.programme"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="programme in programmes"
								v-bind:key="programme.Id"
								:value="programme.Id"
							>{{programme.Name}}</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('year') }}</label>
						<select
							type="text"
							v-model="search.year"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="year in years"
								v-bind:key="year.id"
								:value="year.id"
							>{{year.caption}}</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('term') }}</label>
						<select
							type="text"
							v-model="search.term"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="schoolterm in schoolterms"
								v-bind:key="schoolterm.id"
								:value="schoolterm.id"
							>{{schoolterm.caption}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('firm') }}</label>
						<select
							type="text"
							v-model="search.selected_student_firm"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="(caption, key) in $config.getValue('firms')"
								v-bind:key="key"
								:value="key"
							>{{caption}}</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('group') }}</label>
						<select
							type="text"
							v-model="search.selected_student_group"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="(caption, key) in $config.getValue('groups')"
								v-bind:key="key"
								:value="key"
							>{{caption}}</option>
						</select>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group">
						<label>{{ $t('specialty') }}</label>
						<select
							type="text"
							v-model="search.specialty"
							class="form-control"
							@change="newSearch"
						>
							<option value="">{{ $t('select-caps') }}</option>
							<option
								v-for="specialty in this.$config.getValue('specialties')"
								v-bind:key="specialty.id"
								:value="specialty.id"
							>{{specialty.name}}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-9">
				<div class="input-group mb-3">
					<input type="text" :placeholder="$t('search-ellipses')" v-model="search.q" class="form-control form-control-lg" @keyup.enter="newSearch" />
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
						<button class="btn btn-outline-primary" v-on:click="showadvancedsearch = !showadvancedsearch">{{ $t('advanced') }}</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/reports/saved/report/"
					>{{ $t('new-report') }}</router-link
				>
			</div>
		</div>

		<InfiniteScroll
		scrollElementId="main"
		type="SavedReport"
		:dataUrl="`${$settings.APIBaseURL}/savedreports/list`"
		dataProperty="results"
		class="list-group border-radius-2 no-border"
		itemClass="list-group-item"
		@selectItem="selectReport"
		ref="infinitescroll"
		/>

	</div>
</template>

<script>
import InfiniteScroll from "../../../components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll,
	},
	data() {
		return {
			showadvancedsearch: false,
			search: {
				q: null,
				teacher: null,
				programme: null,
				schooltermsession: null,
				year: null,
				term: null,
				selected_student_firm: null,
				selected_student_group: null,
				date_from: null,
				date_to: null,
				session_type: null,
				specialty: null
			}
		};
	},
	mounted() {
		//this.getFormSettings();
		this.getSavedReports();
	},
	methods: {
		newSearch() {
			if(!this.showadvancedsearch){
				this.search = {
					q: this.search.q,
					programme: null,
					schooltermsession: null,
					year: null,
					term: null,
					selected_student_firm: null,
					selected_student_group: null,
					specialty: null
				}
			}
			this.getSavedReports();
		},
		getSavedReports() {
			const body = this.search;
			this.$refs.infinitescroll.getData('replace', body)
		},
		selectReport(report) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/reports/saved/report/${report.id}`);
		},
		/*
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t('select-a-student'),
					selectCallback: function(selection) {
						if(self.search.student == selection.id){
							self.search.student_displayname = '';
							self.search.student = selection.null;
						} else {
							self.search.student_displayname = selection.displayName;
							self.search.student = selection.id;
						}
						self.$store.commit("closeModal");
					},
					selected: [{
						id: this.search.student
					}],
					data: students,
					captionKey: 'displayName'
				});
			});
		},
		selectTeacher(){
			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t('select-a-teacher'),
					selectCallback: function(selection) {
						if(self.search.teacher == selection.id){
							self.search.teacher_displayname = '';
							self.search.teacher = null;
						} else {
							self.search.teacher_displayname = selection.displayName;
							self.search.teacher = selection.id;
						}
						self.$store.commit("closeModal");
					},
					selected: [{
						id: this.search.teacher
					}],
					data: teachers,
					captionKey: 'displayName'
				});
			});
		}
		*/
	},
	computed: {
		isTeacher: function(){
			return this.$UserSession.hasPriv.call(this, 'MARK_TREATMENTSESSIONS');
		},
		programmes: function(){
			return this.$config.getValue('programmes');
		},
		schooltermsessions: function(){
			var options = []
			var schooltermsessions = this.$config.getValue('schooltermsessions');
			for(var index in schooltermsessions){
				var item = schooltermsessions[index];
				if(item.programme_id == this.search.programme){
					options.push({
						id: item.schooltermsession_id  ,
						caption: item.schooltermsession_title
					});
				}
			};
			return options;
		},
		years: function(){
			var options = []
			if(this.search.programme in this.programmes){
				var max = this.programmes[this.search.programme].CourseLengthYears;
				for(var i=1; i<=max; i++){
					options.push({
						id: i ,
						caption: i
					});
				}
			}
			return options;
		},
		schoolterms: function(){
			var options = []
			var schoolterms = this.$config.getValue('schoolterms');
			for(var index in schoolterms){
				var item = schoolterms[index];
				if(item.programme_id == this.search.programme){
					if(item.schoolyear_id == this.search.year){
						options.push({
							id: item.schoolterm_id  ,
							caption: item.schoolterm_title
						});
					}
				}
			};
			return options;
		}
	}
};
</script>
